import { ElementRef, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavigationRootService {
  constructor() {}
  voidtocall(type: any) {
    if (type == 'prd') {
      return 'getprdlist';
    }
    if (type == 'size') {
      return 'getsizelist';
    }
    return 'no any match';
  }
  focusNextInput(event: any) {
    if (event.key === 'ArrowUp' || (event.key === 'Tab' && event.shiftKey)) {
      event.preventDefault();
      this.moveToPreviousInput(event);
    } else if (event.key === 'Enter' || event.key === 'ArrowDown' || event.key == 'Tab') {
      event.preventDefault();
      this.moveToNextInput(event);
    } else if (event.key === 'Nextfocus') {
      this.moveToNextInput(event);
    } else if (event.key === 'F2') {
      event.preventDefault();
      this.skipTableInputs(event);
    }
  }

  focusInput(el: any, controlName: any) {
    const inputElement = el.nativeElement.querySelector(`[formControlName="${controlName}"]`);
    if (inputElement) {
      inputElement.focus();
    }
  }
  labelfocus(event: any) {
    const element = event.target as HTMLElement;
    const parentContainer = element.closest('mat-form-field') as HTMLElement;
    if (parentContainer) {
      const allContainers = Array.from(document.querySelectorAll('mat-form-field'));
      const currentIndex = allContainers.indexOf(parentContainer);

      let nextContainer = allContainers[currentIndex];
      while (nextContainer) {
        const nextInput = nextContainer.querySelector('input, textarea') as HTMLElement;

        if (nextInput) {
          nextInput.focus();
          return;
        }
      }
    }
  }

  moveToNextInput(event: KeyboardEvent) {
    const element = event.target as HTMLElement;
    const parentContainer = element.closest('mat-form-field') as HTMLElement;
    const dialogContainer = document.querySelector('mat-dialog-container');
    if (parentContainer) {
      const allContainers = dialogContainer ? Array.from(dialogContainer.querySelectorAll('mat-form-field')) : Array.from(document.querySelectorAll('mat-form-field'));
      const currentIndex = allContainers.indexOf(parentContainer);
      let nextContainer = allContainers[currentIndex + 1];
      while (nextContainer) {
        const nextInput = nextContainer.querySelector('input, textarea') as HTMLElement;
        if (element.classList.contains('skipthis')) {
          this.nextValidSkipInput(nextInput, event);
          return;
        }
        if (nextInput && !nextInput.hasAttribute('disabled') && !nextInput.classList.contains('skipthis') && nextInput.getAttribute('readonly') !== 'true') {
          nextInput.focus();
          return;
        }
        nextContainer = allContainers[allContainers.indexOf(nextContainer) + 1];
      }
      const skipInputs = dialogContainer ? dialogContainer.querySelectorAll('input.skipthis, textarea.skipthis') : document.querySelectorAll('input.skipthis, textarea.skipthis');
      if (skipInputs.length > 0) {
        this.focusFirstValidSkipInput(skipInputs, event); // Call the helper function to focus on skipthis inputs
      } else {
        // If no skipthis inputs are found, call savebuttonfocus
        this.savebuttonfocus(event);
      }
    }
  }
  nextValidSkipInput(skipInputs: any, event: KeyboardEvent) {
    if (!skipInputs.classList.contains('skipthis')) {
      this.savebuttonfocus(event);
      return;
    }
    skipInputs.focus();
    return;
  }
  focusFirstValidSkipInput(skipInputs: any, event: KeyboardEvent) {
    skipInputs[0].focus();
    return;
  }
  skipTableInputs(event: KeyboardEvent) {
    const element = event.target as HTMLElement;
    const tableElement = element?.closest('table') as HTMLElement;
    const dialogContainer = document?.querySelector('mat-dialog-container');

    if (tableElement) {
      // Select all focusable elements across the DOM
      const focusableElements = dialogContainer ? (Array.from(dialogContainer.querySelectorAll('input, textarea, button.save-button-class')).filter((el) => el instanceof HTMLElement && !el.hasAttribute('disabled')) as HTMLElement[]) : (Array.from(document.querySelectorAll('input, textarea, button.save-button-class')).filter((el) => el instanceof HTMLElement && !el.hasAttribute('disabled')) as HTMLElement[]);

      // Find the current focused element in the list of focusable elements
      const currentElementIndex = focusableElements.indexOf(element);

      for (let i = currentElementIndex + 1; i < focusableElements.length; i++) {
        const nextElement = focusableElements[i];

        if (nextElement.classList.contains('save-button-class')) {
          const skipInputs = dialogContainer ? dialogContainer.querySelectorAll('input.skipthis, textarea.skipthis') : document.querySelectorAll('input.skipthis, textarea.skipthis');
          if (skipInputs.length > 0) {
            this.focusFirstValidSkipInput(skipInputs, event); // Call the helper function to focus on skipthis inputs
            return;
          } else {
            // If no skipthis inputs are found, call savebuttonfocus
            nextElement.focus();
            return;
          }
        }
        if (!tableElement.contains(nextElement) && !nextElement.classList.contains('skipthis')) {
          nextElement.focus();
          return;
        }
      }
    }

    this.savebutton();
  }
  savebuttonfocus(event: any) {
    const dialogContainer = document.querySelector('mat-dialog-container');

    const saveButton = dialogContainer ? (dialogContainer.querySelector('button.save-button-class') as HTMLButtonElement) : (document.querySelector('button.save-button-class') as HTMLButtonElement);
    if (event.key != 'Nextfocus') {
      if (saveButton) {
        saveButton.focus();
      } else {
        console.error('Save button not found!');
      }
    }
  }
  moveToPreviousInput(event: KeyboardEvent): void {
    const element = event.target as HTMLElement;
    const parentContainer = element.closest('mat-form-field') as HTMLElement;
    const dialogContainer = document.querySelector('mat-dialog-container');

    if (parentContainer) {
      // let prevContainer = parentContainer.previousElementSibling as HTMLElement;
      const allContainers = dialogContainer ? Array.from(dialogContainer.querySelectorAll('mat-form-field')) : Array.from(document.querySelectorAll('mat-form-field'));

      const currentIndex = allContainers.indexOf(parentContainer);

      let prevContainer = allContainers[currentIndex - 1];
      while (prevContainer) {
        const previousInput = prevContainer.querySelector('input,textarea') as HTMLElement;
        if (previousInput && !previousInput.hasAttribute('disabled') && previousInput.getAttribute('readonly') !== 'true') {
          previousInput.focus();
          return;
        }
        prevContainer = allContainers[allContainers.indexOf(prevContainer) - 1];
        // prevContainer = prevContainer.previousElementSibling as HTMLElement;
      }
    }
  }
  savebutton() {
    const dialogContainer = document.querySelector('mat-dialog-container');
    const saveButton = dialogContainer ? (dialogContainer.querySelector('button.save-button-class') as HTMLButtonElement) : (document.querySelector('button.save-button-class') as HTMLButtonElement);
    if (saveButton) {
      saveButton.focus();
    } else {
      console.error('Save button not found!');
    }
  }
}
